import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import scanImg from "../../../../../picture/scan.png";
import editImg from "../../../../../picture/edit.png";
import visibleImg from "../../../../../picture/Visible.png";
import { useGlobalContext } from "../../../../../Context/Context";
import AzuriranjeDokumenta from "./AzuriranjeDokumenta";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  button: { padding: "10px 30px" },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  },
  plusButton: { width: "30px", fontWeight: "bold" },
};

function LZOTabelaAzuriranje() {
  const [allData, setAllData] = useState([]);
  const [initialAllData, setInitialAllData] = useState([]);
  const [selectedLzoId, setSelectedLzoId] = useState(null);
  const [dokumenta, setDokumenta] = useState([]);
  const [editDokument, setEditDokument] = useState(null);
  const [saving, setSaving] = useState(false);

  const {
    setFolderDokumentCurrentState,
    selectedMainEntity,
    baseUrl,
    lzoVrstaDokumenta,
  } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/lzo_firma/read.php`, {
        company_id: selectedMainEntity.company_id,
      });
      if (data.status === 200) {
        const aktivni = data.data.filter((d) => d.is_arhivirano == 0);
        setAllData(aktivni);
        setInitialAllData(JSON.parse(JSON.stringify(aktivni)));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchDokumenta = async (lzo_firma_id) => {
    try {
      const { data } = await axios.post(`${baseUrl}/lzo_dokumenta/read.php`, {
        lzo_firma_id,
      });
      if (data.status === 200) setDokumenta(data.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
  }, [selectedMainEntity]);

  useEffect(() => {
    if (selectedLzoId) fetchDokumenta(selectedLzoId);
    else setDokumenta([]);
  }, [selectedLzoId]);

  const changeIzd = (id) =>
    setAllData(
      allData.map((d) =>
        d.id === id
          ? { ...d, izd: parseInt(d.izd) + 1, mag: parseInt(d.mag) - 1 }
          : d,
      ),
    );
  const changeMag = (id) =>
    setAllData(
      allData.map((d) =>
        d.id === id
          ? { ...d, izd: parseInt(d.izd) - 1, mag: parseInt(d.mag) + 1 }
          : d,
      ),
    );
  const changeOtp = (id) =>
    setAllData(
      allData.map((d) =>
        d.id === id
          ? { ...d, otp: parseInt(d.otp) + 1, izd: parseInt(d.izd) - 1 }
          : d,
      ),
    );

  const handleSacuvaj = async () => {
    setSaving(true);
    try {
      await Promise.all(
        allData.map((item) =>
          axios.post(`${baseUrl}/lzo_firma/updateKolicina.php`, {
            id: item.id,
            izd: item.izd,
            mag: item.mag,
            otp: item.otp,
          }),
        ),
      );
      setFolderDokumentCurrentState("");
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  if (editDokument)
    return (
      <AzuriranjeDokumenta
        dokument={editDokument}
        cancel={() => setEditDokument(null)}
        onRefresh={() => selectedLzoId && fetchDokumenta(selectedLzoId)}
      />
    );

  return (
    <div
      style={{
        padding: "20px",
        fontSize: "14px",
        height: "100%",
        width: "100%",
        backgroundColor: "#F9F9F9",
      }}
    >
      <style>{`#azur-tabela td, #azur-tabela th { font-size: 14px !important; }`}</style>
      <div
        style={{ overflowY: "auto", height: "calc(100% - 50px)" }}
        id="azur-tabela"
      >
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={styles.cell}></th>
              <th style={styles.cell}>Rb.</th>
              <th style={{ ...styles.cell, width: "50%" }}>
                LIČNA ZAŠTITNA OPREMA
              </th>
              <th style={styles.cell}>IZDATO</th>
              <th style={styles.cell}>MAGACIN</th>
              <th style={styles.cell}>SVEGA</th>
              <th style={styles.cell}>OTPIS</th>
            </tr>
          </thead>
          <tbody>
            {allData.map((item, i) => (
              <tr
                key={item.id}
                style={{
                  backgroundColor: selectedLzoId === item.id ? "#e8f4e8" : "",
                }}
              >
                <td style={{ width: "10px"  }}>
                  <input
                  style={{ width: "50px"}}
                    type="checkbox"
                    checked={selectedLzoId === item.id}
                    onChange={() =>
                      setSelectedLzoId(
                        selectedLzoId === item.id ? null : item.id,
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>{i + 1}.</td>
                <td style={styles.cell}>{item.naziv}</td>
                <td style={styles.cell}>
                  <div style={styles.flex}>
                    <div>{item.izd}</div>
                    {["", "REVERS"].includes(lzoVrstaDokumenta || "") && (
                      <div onClick={() => changeIzd(item.id)}>
                        <Button activation={true} style={styles.plusButton}>
                          +
                        </Button>
                      </div>
                    )}
                  </div>
                </td>
                <td style={styles.cell}>
                  <div style={styles.flex}>
                    <div>{item.mag}</div>
                    {["", "MAGACIN", "RAZDUZENJE"].includes(
                      lzoVrstaDokumenta || "",
                    ) && (
                      <div onClick={() => changeMag(item.id)}>
                        <Button activation={true} style={styles.plusButton}>
                          +
                        </Button>
                      </div>
                    )}
                  </div>
                </td>
                <td style={styles.cell}>
                  {parseInt(item.izd) + parseInt(item.mag)}
                </td>
                <td style={styles.cell}>
                  <div style={styles.flex}>
                    <div>{item.otp}</div>
                    {["", "OTPIS", "RAZDUZENJE"].includes(
                      lzoVrstaDokumenta || "",
                    ) && (
                      <div onClick={() => changeOtp(item.id)}>
                        <Button activation={true} style={styles.plusButton}>
                          +
                        </Button>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {selectedLzoId && (
          <table style={{ width: "100%", marginTop: "30px" }}>
            <thead>
              <tr>
                <th style={styles.cell}>
                  <img src={scanImg} style={{ width: "20px" }} />
                </th>
                <th style={{ ...styles.cell, width: "40%" }}>
                  DODATA DOKUMENTA
                </th>
                <th style={styles.cell}>DATUM</th>
                <th style={{ ...styles.cell, width: "20%" }}>IME I PREZIME</th>
                <th style={{ ...styles.cell, width: "20%" }}>RADNO MESTO</th>
                <th style={styles.cell}></th>
                <th style={styles.cell}></th>
              </tr>
            </thead>
            <tbody>
              {dokumenta.map((item, i) => (
                <tr key={item.id}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          backgroundColor: "green",
                        }}
                      ></div>
                    </div>
                  </td>
                  <td style={styles.cell}>{item.naziv}</td>
                  <td style={styles.cell}>{item.datum}</td>
                  <td style={styles.cell}>
                    {item.zaposleni?.map((z) => z.name).join(", ")}
                  </td>
                  <td style={styles.cell}>
                    {item.radna_mesta?.map((r) => r.name).join(", ")}
                  </td>
                  <td
                    style={{ ...styles.cell, cursor: "pointer" }}
                    onClick={() => setEditDokument(item)}
                  >
                    <img src={editImg} style={{ width: "20px" }} />
                  </td>
                  <td style={{ ...styles.cell, cursor: "pointer" }}>
                    <img src={visibleImg} style={{ width: "25px" }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
        }}
      >
        <div onClick={() => setFolderDokumentCurrentState("")}>
          <Button activation={true} style={styles.button}>
            ODUSTANI
          </Button>
        </div>
        <div
          onClick={() => {
            setAllData(JSON.parse(JSON.stringify(initialAllData)));
          }}
        >
          <Button activation={true} style={styles.button}>
            RESETUJ
          </Button>
        </div>
        <div
          onClick={saving ? undefined : handleSacuvaj}
          style={{ opacity: saving ? 0.5 : 1 }}
        >
          <Button activation={true} style={styles.button}>
            SAČUVAJ
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LZOTabelaAzuriranje;
